import { Box, Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spacer, Text } from "@chakra-ui/react"


const DoctorDeleteModal = ({isDeleteModalOpen, setDeleteModalOpen, selectedDeleteDoctor, handleDeleteDoctor }) => {
    return <>
        {/* Modal for Delete Confirmation */}
      <Modal
        size={"xl"}
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ยืนยันการลบแพทย์</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            คุณต้องการลบแพทย์ "
            {selectedDeleteDoctor &&
              `${selectedDeleteDoctor.first_name} ${selectedDeleteDoctor.last_name}`}
            " ใช่หรือไม่?
            <Flex my={4} justify={"initial"} align={"flex-start"}>
              <Text minW={"80px"} mr={2} color={"red.700"} fontWeight={500}>
                คำเตือน:
              </Text>
              <Text>
                {" "}
                การลบแพทย์จะทำให้ข้อมูลของแพทย์ที่ลบหายไปทั้งหมด
                (ข้อมูลสถิติรายวัน รายเดือน และรายปี
                ของแพทย์ท่านี้จะหายไปทั้งหมด).
              </Text>
            </Flex>
            <Flex my={4} justify={"initial"} align={"flex-start"}>
              <Text minW={"80px"} mr={2} color={"green.700"} fontWeight={500}>
                คำแนะนำ:
              </Text>
              <Flex direction={"column"}>
              <Text mb={4}>
                {" "}
                <b>กรณีที่แพทย์ "ไม่ได้" ปฎิบัติงานในแผนกแล้ว</b>{" "}และต้องการเก็บข้อมูลเดิมของแพทย์ไว้
                (เช่น ข้อมูลสถิติรายวัน รายเดือน และรายปี)
                ให้เปลี่ยนสถานะของแพทย์ท่านนั้นเป็น <b>inactive</b>
              </Text>
              <Text>
                {" "}
                <b>กรณีที่แพทย์ยังปฎิบัติงานในแผนกอยู่</b>{" "}และต้องการเก็บข้อมูลเดิมของแพทย์ไว้
                (เช่น ข้อมูลสถิติรายวัน รายเดือน และรายปี) รวมทั้งต้องการคงสถานะแพทย์เป็น <b>active</b> แต่ไม่ต้องการแสดงข้อมูลของแพทย์ท่านนี้อีกต่อไป
                แนะนำให้ทำการอัพเดท "วันที่สิ้นสุดการตรวจ" ในทุกวันที่ออกตรวจ
              </Text>
              </Flex>
            </Flex>
          </ModalBody>
          <ModalFooter bgColor={"gray.200"}>
            <Flex w="100%" justify={"space-between"}>
              <Button mr={2} colorScheme="red" onClick={handleDeleteDoctor}>
                ลบแพทย์
              </Button>
              <Spacer />
              <Button variant="ghost" onClick={() => setDeleteModalOpen(false)}>
                ยกเลิก
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
}

export default DoctorDeleteModal;